import { translate } from '@vimeo/i18n-runtime';

import { PlanData } from './interface';

const translations = {
  compareAllPlans: translate('Compare all plans'),
  compareAllPlanFeatures: translate('Compare all plan features'),
  contactSales: translate('Contact sales'),
  defaultHeader: translate('Upgrade to unlock more video tools'),
  defaultSubHeader: translate(
    'Upgrade for full access to creation tools and more storage for your videos.',
  ),
  everythingInPlan: (plan: string) => {
    return translate({
      singular: 'Everything in {PLAN}',
      replacements: { PLAN: plan },
    });
  },
  keyFeatures: translate('Key features'),
  monthlyBillingInfo: translate('per user/month, billed monthly'),
  recommended: translate('Recommended'),
  startFreeTrial: translate('Start free trial'),
  talkToTeam: translate('Talk to our team for pricing.'),
  upgrade: translate('Upgrade'),
  yearlyBillingInfo: translate('per user/month, billed yearly'),
  addOnCardHeading: translate('Or try an add-on'),
  addOnPlanTitle: translate('20 videos'),
  addOnPlanSubTitle: translate('Create and edit videos with premium tools'),
  addOnPlanPrice: translate('$24'),
  addOnPlanBillingInfo: translate('per year, billed yearly'),
  viewAllFeatures: translate('View all features'),
  billedMonthly: translate('billed monthly'),
  billedAnnually: translate('billed annually'),
  perSeatPerMonth: translate('per seat / month'),
  perMonth: translate('per month'),
  perMonthBilledAnually: translate('per month, billed annually'),
  morePlanDetails: translate('More plan details'),
  unlimitedVideos: translate('Unlimited videos'),
  moreTeamMembers: translate('More team members'),
  authenticationProtocols: translate('SSO (SAML) and SCIM (OKTA, AZURE)'),
  advancedMarketingIntegrations: translate('Advanced marketing integrations'),
  backupStreams: translate('Backup streams'),
  doMoreWithEnterprise: translate('Do more with Enterprise'),
  contactUs: translate('Contact us'),
  productBenefits: translate(
    'Dedicated support, custom permissions, increased security, and a whole lot more.',
  ),
  orPriceBilledMonthly: (planData: PlanData) =>
    translate({
      singular: 'or {CURRENCY}{PRICE} billed monthly',
      replacements: {
        PRICE: planData.price.monthly,
        CURRENCY: planData.currency.symbol,
      },
    }),
};

export default translations;
